import { Getters } from 'vuex-smart-module';
import SoftwareLicensesState from './state';

export default class SoftwareLicensesGetters extends Getters<SoftwareLicensesState> {}
